export const widget_text_en: any = {
    "": "Not available",
    "lifts": "Lifts",
    "trails": "Trails",
    "season_start": "Season starts",
    "season_end": "Season ends",
    "updated": "Updated:",
    "source": "Weather forecast source:",
    "view more": "View more",
    "access": "Accesses",
    "parking": "Parking",
    "next week": "Next days",
}

export const widget_text_de: any = {
    "": "Nicht verfügbar",
    "lifts": "Skilift",
    "trails": "Skipiste",
    "season_start": "Saisonbeginn",
    "season_end": "Saisonende",
    "updated": "Aktualisiert:",
    "source": "Wettervorhersagequelle:",
    "access": "Zugänge",
    "parking": "Parkplatz",
    "next week": "Nächste Tage",
}

export const widget_text_fr: any = {
    "": "Non disponible",
    "lifts": "Remontées",
    "trails": "Pistes",
    "season_start": "Début de la saison",
    "season_end": "Fin de la saison",
    "updated": "Mis à jour :",
    "source": "Source de prévision météorologique:",
    "access": "Accès",
    "parking": "Stationnement",
    "next week": "Prochains jours",
}

export const widget_text_it: any = {
    "": "Non disponibile",
    "lifts": "Impianti di risalita",
    "trails": "Piste",
    "season_start": "Inizio stagione",
    "season_end": "Fine stagione",
    "updated": "Aggiornato:",
    "source": "Fonte del previsioni meteo:",
    "access": "Accessi",
    "parking": "Parcheggio",
    "next week": "Prossimi giorni",
}

export const widget_text_es: any = {
    "": "No disponible",
    "lifts": "Remontes",
    "trails": "Pistas",
    "season_start": "Inicio de la temporada",
    "season_end": "Fin de la temporada",
    "updated": "Actualizado:",
    "source": "Fuente de pronóstico del tiempo:",
    "access": "Accesos",
    "parking": "Estacionamiento",
    "next week": "Próximos días",
}

export const widget_text_nb: any = {
    "": "Ikke tilgjengelig",
    "lifts": "Heiser",
    "trails": "Bakker",
    "season_start": "Sesong starter",
    "season_end": "Sesong slutter",
    "updated": "Oppdatert:",
    "source": "Kilde for værmelding:",
    "view more": "Se mer",
    "access": "Tilganger",
    "parking": "Parkering",
    "next week": "Neste dager",
}
